import loadable from '@loadable/component';

const Products = loadable(() => import('./index'), {
  resolveComponent: module => module.ProductsContainer,
});
export default Products;
